import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11 20c-.2 0-.4-.1-.6-.2L5.6 16H2c-.6 0-1-.4-1-1V9c0-.6.4-1 1-1h3.6l4.7-3.8c.3-.2.7-.3 1.1-.1q.6.3.6.9v14q0 .6-.6.9c-.1.1-.3.1-.4.1m6-4c-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4l6-6c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-6 6c-.2.2-.4.3-.7.3"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M23 16c-.3 0-.5-.1-.7-.3l-6-6c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l6 6c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3"
    }, null, -1)
  ]))]))
}
export default { render: render }